import { FC, useEffect } from "preact/compat";
import { intervalToDuration } from "date-fns";
import { useForceRender } from "~/hooks";
import { leadZero } from "~/utils";
import type { TimeDistanceProps } from "./interfaces";

const EACH_MINUTE = 1000 * 60;

const TimeDistance: FC<TimeDistanceProps> = ({
    date,
    baseDate,
    className,
    period = EACH_MINUTE,
    withSeconds = false,
}) => {
    const rerender = useForceRender();

    useEffect(() => {
        const intervalId = window.setInterval(rerender, period);

        return () => window.clearInterval(intervalId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [period]);

    const duration = intervalToDuration({
        start: date,
        end: baseDate || new Date(),
    });

    return (
        <span className={className}>
            {leadZero(duration.hours)}:{leadZero(duration.minutes)}
            {withSeconds ? `:${leadZero(duration.seconds)}` : ""}
        </span>
    );
};

export default TimeDistance;
